package co.maytes.standupbot.dashboard.features.standupruns

import kotlinx.datetime.Instant

/** Thin dashboard-side re-export so feature call-sites don't reach across modules. */
fun formatRelative(instant: Instant): String =
    co.maytes.standupbot.shared.util.RelativeTime.format(instant)

fun formatAbsolute(instant: Instant): String =
    co.maytes.standupbot.shared.util.RelativeTime.formatDateTime(instant)

/**
 * Format an integer cents amount as `$0.0234` with 4 decimal places.
 * Right-aligned presentation happens at call sites; this returns the raw string.
 */
fun formatCents(cents: Int): String {
    val dollars = cents / 100.0
    // Integer part + 4-decimal fraction. Hand-roll because Kotlin/JS doesn't
    // have the same String.format options as JVM; stick to basic multiplication.
    val totalTenThousandths = (dollars * 10_000).toLong()
    val whole = totalTenThousandths / 10_000
    val frac = (totalTenThousandths % 10_000).let { if (it < 0) -it else it }
    val fracStr = frac.toString().padStart(4, '0')
    val sign = if (totalTenThousandths < 0) "-" else ""
    return "$sign$$whole.$fracStr"
}
